/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Antonio Rodriguez",
  title: "Hola! I'm Antonio",
  subTitle: emoji(
    `I work as a Site Reliability Engineer specializing in performance and reliability at Delta Airlines. In my current job and others, I have gained experience both in the field of DevOps and Cloud Native Application Development. 
    I have a passion to continue to grow in knowledge and leadership, excel in innovative technology and business applications.
    `
  ),
  resumeLink:
    "https://drive.google.com/file/d/1Vi6g_DCW3vjyZV557wm319pZbLHsL4oO/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/antoniordz96",
  linkedin: "https://www.linkedin.com/in/antoniordz96/",
  gmail: "antoniordz675@outlook.com",
  medium: "https://medium.com/@antoniordz96",
  stackoverflow: "https://stackoverflow.com/users/10834039/antonio-rodriguez",
  facebook: "https://www.facebook.com/ajr80231",
  instagram: "https://www.instagram.com/tony_rodriguez9610/",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: 'As a wise man once said "AUTOMATE ALL THINGS!"',
  skills: [
    emoji(
      "⚡ Helping large enterpise customers migrate on-prem applications to the cloud. Specifically focusing on containerization."
    ),
    emoji(
      "⚡ Responsible for designing and developing resiliency in the infrastructure/application, troubleshooting incidents, engaging with varius teams to address failure patterns, and participating in incident management"
    ),
    emoji(
      "⚡ Helping others uplevel their skills and become better cloud engineers :) "
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "GCP",
      icon: require("./assets/images/icons/gcp.png")
    },
    {
      skillName: "AWS",
      icon: require("./assets/images/icons/aws.webp")
    },
    {
      skillName: "Kubernetes",
      icon: require("./assets/images/icons/kubernetes.png")
    },
    {
      skillName: "Anthos",
      icon: require("./assets/images/icons/anthos.png")
    },
    {
      skillName: "Openshift",
      icon: require("./assets/images/icons/openshift.png")
    },
    {
      skillName: "Terraform",
      icon: require("./assets/images/icons/terraform.png")
    },
    {
      skillName: "Tekton",
      icon: require("./assets/images/icons/tekton.webp")
    },
    {
      skillName: "Istio",
      icon: require("./assets/images/icons/istio.svg")
    },
    {
      skillName: "Gitops",
      icon: require("./assets/images/icons/gitops.png")
    },
    {
      skillName: "Python",
      icon: require("./assets/images/icons/python.png")
    },
    {
      skillName: "Java",
      icon: require("./assets/images/icons/java.png")
    },
    {
      skillName: "docker",
      icon: require("./assets/images/icons/docker.png")
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of Georgia",
      logo: require("./assets/images/uga.jpg"),
      subHeader: "Bachelor's of Science in Computer Science",
      duration: "August 2015 - May 2020",
      descBullets: [
        "1st Place Winner of <a target='_blank' href='https://newswire.caes.uga.edu/story/6151/FABricate-Winners.html'> FABricate Entrepreneurship Contest</a>",
        "2nd Place Winners of <a target='_blank' href='https://devpost.com/software/bar-app'>UGA Hacks -2019</a>"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "GCP", //Insert stack or technology you have experience in
      progressPercentage: "100%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Site Reliability Engineer",
      company: "Delta Airlines",
      companylogo: require("./assets/images/companies/delta2.jpg"),
      date: "July 2021 – Present",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Technical Solutions Engineer",
      company: "Google",
      companylogo: require("./assets/images/companies/google-logo.webp"),
      date: "July 2020 – July 2021",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Cloud Technical Resident",
      company: "Google",
      companylogo: require("./assets/images/companies/google-logo.webp"),
      date: "July 2019 – July 2020",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  ],
  internships: [
    {
      role: "Cybersecurity & Privacy Consultant",
      company: "PWC",
      companylogo: require("./assets/images/companies/pwc.png"),
      date: "June 2018 - August 2018",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Systems Infrastructure Engineer",
      company: "E*TRADE",
      companylogo: require("./assets/images/companies/etrade.jpeg"),
      date: "July 2020 – July 2021",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Certifications 🏆 "),
  subtitle:
    "Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Cloud Associate Engineer",
      subtitle:
        "Associate Cloud Engineers deploy applications, monitor operations, and manage enterprise solutions.",
      image: require("./assets/images/google-associate-engineer.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credential.net/eb47d5fb-866a-4175-b401-cbbbea080818#gs.dyq7id"
        }
      ]
    },
    {
      title: "Google Cloud Professional Cloud Architect",
      subtitle:
        "With a thorough understanding of cloud architecture and Google Cloud, they design, develop, and manage robust, secure, scalable, highly available, and dynamic solutions to drive business objectives.",
      image: require("./assets/images/google-pca.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credential.net/339a39b3-cf52-4755-9f9e-57356f19ba4e"
        }
      ]
    }
  ],
  display: true, // Set false to hide this section, defaults to true
  inProgress: []
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle: "Coming soon :)",

  blogs: [
    // {
    //   url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
    //   title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
    //   description:
    //     "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    // },
    // {
    //   url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
    //   title: "Why REACT is The Best?",
    //   description:
    //     "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "Recommendations",
  subtitle: emoji(
    "I love to share the resources that has helped me become a subject matter expert  😅"
  ),

  talks: [
    {
      title: "Kubernetes the Hard Way",
      subtitle: "Deploying k8s with Kelcy Hightower",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Need help or just want to say hi? Feel free to reach out!",
  number: "+1 770-946-6871",
  email_address: "antoniordz675@outlook.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
